// extracted by mini-css-extract-plugin
module.exports = {"EducationalHero":"EducationalHero_EducationalHero__3Dity"};